import React, { useEffect } from 'react';
import { components } from 'react-select';
import styled from 'styled-components';
import { TaskType } from 'api/tasks';
import { TimesheetEntryType } from 'api/timesheets';
import { ReactComponent as Activity24Icon } from 'assets/svgs/activity.svg';
import {
  ListItem,
  ListItemMeta,
  SingleLineLabel,
} from 'components/atoms/select/custom-components';
import { OptionProps } from 'components/atoms/select/types';
import { StatusIndicatorIcon } from 'components/molecules/status-indicator';
import { StatusIndicatorWrapper } from 'components/organisms/timesheets/common/cells/name-cell';
import {
  ClickEventTags,
  LogType,
  useLoadLoggerForDataDog,
} from 'hooks/use-data-dog-logger';

const StyledListItem = styled(ListItem)`
  display: flex;
  align-items: center;
  gap: var(--spacing-05);
`;

export const EntityOption = (props: OptionProps): JSX.Element => {
  const { data, isFocused, isSelected } = props;

  const getTaskField = (fields, fieldName) =>
    fields.find((field) => field.fieldName === fieldName);

  const { executeLogger } = useLoadLoggerForDataDog(
    [ClickEventTags.TimesheetTaskPopupOpen],
    LogType.CallbackLog,
  );

  // Note for future self - had to do it this way otherwise, it wouldn't be logged everytime the component becomes visible
  useEffect(() => {
    executeLogger();
  }, [executeLogger]);

  return (
    <components.Option {...props}>
      <StyledListItem>
        <StatusIndicatorWrapper>
          {[
            TimesheetEntryType.TaskEntry,
            TimesheetEntryType.PhaseEntry,
          ].includes(data.type) ? (
            <StatusIndicatorIcon
              group={
                data.type === TimesheetEntryType.PhaseEntry
                  ? data.extra.fields[0].fieldValue
                  : getTaskField(data.extra.fields, 'Status')?.fieldValue
              }
              type={data.extra.type}
              progress={data.extra.progress}
            />
          ) : (
            <Activity24Icon />
          )}
        </StatusIndicatorWrapper>
        <ListItemMeta
          isFocused={isFocused}
          isSelected={isSelected}
          title={<SingleLineLabel>{data.label}</SingleLineLabel>}
          description={data.description}
          data-cy={`${
            data.extra?.type === TaskType.Milestone
              ? 'MILESTONE_ENTRY'
              : data.type
          }_${data.label}`}
        />
      </StyledListItem>
    </components.Option>
  );
};
